export const countries = [
    {
        "country": "Afghanistan",
        "alpha2": "AF",
        "alpha3": "AFG",
        "numericCode": 4,
        "avgLatitude": 33,
        "avgLongitude": 65
    },
    {
        "country": "Albania",
        "alpha2": "AL",
        "alpha3": "ALB",
        "numericCode": 8,
        "avgLatitude": 41,
        "avgLongitude": 20
    },
    {
        "country": "Algeria",
        "alpha2": "DZ",
        "alpha3": "DZA",
        "numericCode": 12,
        "avgLatitude": 28,
        "avgLongitude": 3
    },
    {
        "country": "American Samoa",
        "alpha2": "AS",
        "alpha3": "ASM",
        "numericCode": 16,
        "avgLatitude": -14.3333,
        "avgLongitude": -170
    },
    {
        "country": "Andorra",
        "alpha2": "AD",
        "alpha3": "AND",
        "numericCode": 20,
        "avgLatitude": 42.5,
        "avgLongitude": 1.6
    },
    {
        "country": "Angola",
        "alpha2": "AO",
        "alpha3": "AGO",
        "numericCode": 24,
        "avgLatitude": -12.5,
        "avgLongitude": 18.5
    },
    {
        "country": "Anguilla",
        "alpha2": "AI",
        "alpha3": "AIA",
        "numericCode": 660,
        "avgLatitude": 18.25,
        "avgLongitude": -63.1667
    },
    {
        "country": "Antarctica",
        "alpha2": "AQ",
        "alpha3": "ATA",
        "numericCode": 10,
        "avgLatitude": -90,
        "avgLongitude": 0
    },
    {
        "country": "Antigua and Barbuda",
        "alpha2": "AG",
        "alpha3": "ATG",
        "numericCode": 28,
        "avgLatitude": 17.05,
        "avgLongitude": -61.8
    },
    {
        "country": "Argentina",
        "alpha2": "AR",
        "alpha3": "ARG",
        "numericCode": 32,
        "avgLatitude": -34,
        "avgLongitude": -64
    },
    {
        "country": "Armenia",
        "alpha2": "AM",
        "alpha3": "ARM",
        "numericCode": 51,
        "avgLatitude": 40,
        "avgLongitude": 45
    },
    {
        "country": "Aruba",
        "alpha2": "AW",
        "alpha3": "ABW",
        "numericCode": 533,
        "avgLatitude": 12.5,
        "avgLongitude": -69.9667
    },
    {
        "country": "Australia",
        "alpha2": "AU",
        "alpha3": "AUS",
        "numericCode": 36,
        "avgLatitude": -27,
        "avgLongitude": 133
    },
    {
        "country": "Austria",
        "alpha2": "AT",
        "alpha3": "AUT",
        "numericCode": 40,
        "avgLatitude": 47.3333,
        "avgLongitude": 13.3333
    },
    {
        "country": "Azerbaijan",
        "alpha2": "AZ",
        "alpha3": "AZE",
        "numericCode": 31,
        "avgLatitude": 40.5,
        "avgLongitude": 47.5
    },
    {
        "country": "Bahamas",
        "alpha2": "BS",
        "alpha3": "BHS",
        "numericCode": 44,
        "avgLatitude": 24.25,
        "avgLongitude": -76
    },
    {
        "country": "Bahrain",
        "alpha2": "BH",
        "alpha3": "BHR",
        "numericCode": 48,
        "avgLatitude": 26,
        "avgLongitude": 50.55
    },
    {
        "country": "Bangladesh",
        "alpha2": "BD",
        "alpha3": "BGD",
        "numericCode": 50,
        "avgLatitude": 24,
        "avgLongitude": 90
    },
    {
        "country": "Barbados",
        "alpha2": "BB",
        "alpha3": "BRB",
        "numericCode": 52,
        "avgLatitude": 13.1667,
        "avgLongitude": -59.5333
    },
    {
        "country": "Belarus",
        "alpha2": "BY",
        "alpha3": "BLR",
        "numericCode": 112,
        "avgLatitude": 53,
        "avgLongitude": 28
    },
    {
        "country": "Belgium",
        "alpha2": "BE",
        "alpha3": "BEL",
        "numericCode": 56,
        "avgLatitude": 50.8333,
        "avgLongitude": 4
    },
    {
        "country": "Belize",
        "alpha2": "BZ",
        "alpha3": "BLZ",
        "numericCode": 84,
        "avgLatitude": 17.25,
        "avgLongitude": -88.75
    },
    {
        "country": "Benin",
        "alpha2": "BJ",
        "alpha3": "BEN",
        "numericCode": 204,
        "avgLatitude": 9.5,
        "avgLongitude": 2.25
    },
    {
        "country": "Bermuda",
        "alpha2": "BM",
        "alpha3": "BMU",
        "numericCode": 60,
        "avgLatitude": 32.3333,
        "avgLongitude": -64.75
    },
    {
        "country": "Bhutan",
        "alpha2": "BT",
        "alpha3": "BTN",
        "numericCode": 64,
        "avgLatitude": 27.5,
        "avgLongitude": 90.5
    },
    {
        "country": "Bolivia, Plurinational State of",
        "alpha2": "BO",
        "alpha3": "BOL",
        "numericCode": 68,
        "avgLatitude": -17,
        "avgLongitude": -65
    },
    {
        "country": "Bolivia",
        "alpha2": "BO",
        "alpha3": "BOL",
        "numericCode": 68,
        "avgLatitude": -17,
        "avgLongitude": -65
    },
    {
        "country": "Bosnia and Herzegovina",
        "alpha2": "BA",
        "alpha3": "BIH",
        "numericCode": 70,
        "avgLatitude": 44,
        "avgLongitude": 18
    },
    {
        "country": "Botswana",
        "alpha2": "BW",
        "alpha3": "BWA",
        "numericCode": 72,
        "avgLatitude": -22,
        "avgLongitude": 24
    },
    {
        "country": "Bouvet Island",
        "alpha2": "BV",
        "alpha3": "BVT",
        "numericCode": 74,
        "avgLatitude": -54.4333,
        "avgLongitude": 3.4
    },
    {
        "country": "Brazil",
        "alpha2": "BR",
        "alpha3": "BRA",
        "numericCode": 76,
        "avgLatitude": -10,
        "avgLongitude": -55
    },
    {
        "country": "British Indian Ocean Territory",
        "alpha2": "IO",
        "alpha3": "IOT",
        "numericCode": 86,
        "avgLatitude": -6,
        "avgLongitude": 71.5
    },
    {
        "country": "Brunei Darussalam",
        "alpha2": "BN",
        "alpha3": "BRN",
        "numericCode": 96,
        "avgLatitude": 4.5,
        "avgLongitude": 114.6667
    },
    {
        "country": "Brunei",
        "alpha2": "BN",
        "alpha3": "BRN",
        "numericCode": 96,
        "avgLatitude": 4.5,
        "avgLongitude": 114.6667
    },
    {
        "country": "Bulgaria",
        "alpha2": "BG",
        "alpha3": "BGR",
        "numericCode": 100,
        "avgLatitude": 43,
        "avgLongitude": 25
    },
    {
        "country": "Burkina Faso",
        "alpha2": "BF",
        "alpha3": "BFA",
        "numericCode": 854,
        "avgLatitude": 13,
        "avgLongitude": -2
    },
    {
        "country": "Burundi",
        "alpha2": "BI",
        "alpha3": "BDI",
        "numericCode": 108,
        "avgLatitude": -3.5,
        "avgLongitude": 30
    },
    {
        "country": "Cambodia",
        "alpha2": "KH",
        "alpha3": "KHM",
        "numericCode": 116,
        "avgLatitude": 13,
        "avgLongitude": 105
    },
    {
        "country": "Cameroon",
        "alpha2": "CM",
        "alpha3": "CMR",
        "numericCode": 120,
        "avgLatitude": 6,
        "avgLongitude": 12
    },
    {
        "country": "Canada",
        "alpha2": "CA",
        "alpha3": "CAN",
        "numericCode": 124,
        "avgLatitude": 60,
        "avgLongitude": -95
    },
    {
        "country": "Cape Verde",
        "alpha2": "CV",
        "alpha3": "CPV",
        "numericCode": 132,
        "avgLatitude": 16,
        "avgLongitude": -24
    },
    {
        "country": "Cayman Islands",
        "alpha2": "KY",
        "alpha3": "CYM",
        "numericCode": 136,
        "avgLatitude": 19.5,
        "avgLongitude": -80.5
    },
    {
        "country": "Central African Republic",
        "alpha2": "CF",
        "alpha3": "CAF",
        "numericCode": 140,
        "avgLatitude": 7,
        "avgLongitude": 21
    },
    {
        "country": "Chad",
        "alpha2": "TD",
        "alpha3": "TCD",
        "numericCode": 148,
        "avgLatitude": 15,
        "avgLongitude": 19
    },
    {
        "country": "Chile",
        "alpha2": "CL",
        "alpha3": "CHL",
        "numericCode": 152,
        "avgLatitude": -30,
        "avgLongitude": -71
    },
    {
        "country": "China",
        "alpha2": "CN",
        "alpha3": "CHN",
        "numericCode": 156,
        "avgLatitude": 35,
        "avgLongitude": 105
    },
    {
        "country": "Christmas Island",
        "alpha2": "CX",
        "alpha3": "CXR",
        "numericCode": 162,
        "avgLatitude": -10.5,
        "avgLongitude": 105.6667
    },
    {
        "country": "Cocos (Keeling) Islands",
        "alpha2": "CC",
        "alpha3": "CCK",
        "numericCode": 166,
        "avgLatitude": -12.5,
        "avgLongitude": 96.8333
    },
    {
        "country": "Colombia",
        "alpha2": "CO",
        "alpha3": "COL",
        "numericCode": 170,
        "avgLatitude": 4,
        "avgLongitude": -72
    },
    {
        "country": "Comoros",
        "alpha2": "KM",
        "alpha3": "COM",
        "numericCode": 174,
        "avgLatitude": -12.1667,
        "avgLongitude": 44.25
    },
    {
        "country": "Congo",
        "alpha2": "CG",
        "alpha3": "COG",
        "numericCode": 178,
        "avgLatitude": -1,
        "avgLongitude": 15
    },
    {
        "country": "Congo, the Democratic Republic of the",
        "alpha2": "CD",
        "alpha3": "COD",
        "numericCode": 180,
        "avgLatitude": 0,
        "avgLongitude": 25
    },
    {
        "country": "Cook Islands",
        "alpha2": "CK",
        "alpha3": "COK",
        "numericCode": 184,
        "avgLatitude": -21.2333,
        "avgLongitude": -159.7667
    },
    {
        "country": "Costa Rica",
        "alpha2": "CR",
        "alpha3": "CRI",
        "numericCode": 188,
        "avgLatitude": 10,
        "avgLongitude": -84
    },
    {
        "country": "Côte d'Ivoire",
        "alpha2": "CI",
        "alpha3": "CIV",
        "numericCode": 384,
        "avgLatitude": 8,
        "avgLongitude": -5
    },
    {
        "country": "Ivory Coast",
        "alpha2": "CI",
        "alpha3": "CIV",
        "numericCode": 384,
        "avgLatitude": 8,
        "avgLongitude": -5
    },
    {
        "country": "Croatia",
        "alpha2": "HR",
        "alpha3": "HRV",
        "numericCode": 191,
        "avgLatitude": 45.1667,
        "avgLongitude": 15.5
    },
    {
        "country": "Cuba",
        "alpha2": "CU",
        "alpha3": "CUB",
        "numericCode": 192,
        "avgLatitude": 21.5,
        "avgLongitude": -80
    },
    {
        "country": "Cyprus",
        "alpha2": "CY",
        "alpha3": "CYP",
        "numericCode": 196,
        "avgLatitude": 35,
        "avgLongitude": 33
    },
    {
        "country": "Czech Republic",
        "alpha2": "CZ",
        "alpha3": "CZE",
        "numericCode": 203,
        "avgLatitude": 49.75,
        "avgLongitude": 15.5
    },
    {
        "country": "Denmark",
        "alpha2": "DK",
        "alpha3": "DNK",
        "numericCode": 208,
        "avgLatitude": 56,
        "avgLongitude": 10
    },
    {
        "country": "Djibouti",
        "alpha2": "DJ",
        "alpha3": "DJI",
        "numericCode": 262,
        "avgLatitude": 11.5,
        "avgLongitude": 43
    },
    {
        "country": "Dominica",
        "alpha2": "DM",
        "alpha3": "DMA",
        "numericCode": 212,
        "avgLatitude": 15.4167,
        "avgLongitude": -61.3333
    },
    {
        "country": "Dominican Republic",
        "alpha2": "DO",
        "alpha3": "DOM",
        "numericCode": 214,
        "avgLatitude": 19,
        "avgLongitude": -70.6667
    },
    {
        "country": "Ecuador",
        "alpha2": "EC",
        "alpha3": "ECU",
        "numericCode": 218,
        "avgLatitude": -2,
        "avgLongitude": -77.5
    },
    {
        "country": "Egypt",
        "alpha2": "EG",
        "alpha3": "EGY",
        "numericCode": 818,
        "avgLatitude": 27,
        "avgLongitude": 30
    },
    {
        "country": "El Salvador",
        "alpha2": "SV",
        "alpha3": "SLV",
        "numericCode": 222,
        "avgLatitude": 13.8333,
        "avgLongitude": -88.9167
    },
    {
        "country": "Equatorial Guinea",
        "alpha2": "GQ",
        "alpha3": "GNQ",
        "numericCode": 226,
        "avgLatitude": 2,
        "avgLongitude": 10
    },
    {
        "country": "Eritrea",
        "alpha2": "ER",
        "alpha3": "ERI",
        "numericCode": 232,
        "avgLatitude": 15,
        "avgLongitude": 39
    },
    {
        "country": "Estonia",
        "alpha2": "EE",
        "alpha3": "EST",
        "numericCode": 233,
        "avgLatitude": 59,
        "avgLongitude": 26
    },
    {
        "country": "Ethiopia",
        "alpha2": "ET",
        "alpha3": "ETH",
        "numericCode": 231,
        "avgLatitude": 8,
        "avgLongitude": 38
    },
    {
        "country": "Falkland Islands (Malvinas)",
        "alpha2": "FK",
        "alpha3": "FLK",
        "numericCode": 238,
        "avgLatitude": -51.75,
        "avgLongitude": -59
    },
    {
        "country": "Faroe Islands",
        "alpha2": "FO",
        "alpha3": "FRO",
        "numericCode": 234,
        "avgLatitude": 62,
        "avgLongitude": -7
    },
    {
        "country": "Fiji",
        "alpha2": "FJ",
        "alpha3": "FJI",
        "numericCode": 242,
        "avgLatitude": -18,
        "avgLongitude": 175
    },
    {
        "country": "Finland",
        "alpha2": "FI",
        "alpha3": "FIN",
        "numericCode": 246,
        "avgLatitude": 64,
        "avgLongitude": 26
    },
    {
        "country": "France",
        "alpha2": "FR",
        "alpha3": "FRA",
        "numericCode": 250,
        "avgLatitude": 46,
        "avgLongitude": 2
    },
    {
        "country": "French Guiana",
        "alpha2": "GF",
        "alpha3": "GUF",
        "numericCode": 254,
        "avgLatitude": 4,
        "avgLongitude": -53
    },
    {
        "country": "French Polynesia",
        "alpha2": "PF",
        "alpha3": "PYF",
        "numericCode": 258,
        "avgLatitude": -15,
        "avgLongitude": -140
    },
    {
        "country": "French Southern Territories",
        "alpha2": "TF",
        "alpha3": "ATF",
        "numericCode": 260,
        "avgLatitude": -43,
        "avgLongitude": 67
    },
    {
        "country": "Gabon",
        "alpha2": "GA",
        "alpha3": "GAB",
        "numericCode": 266,
        "avgLatitude": -1,
        "avgLongitude": 11.75
    },
    {
        "country": "Gambia",
        "alpha2": "GM",
        "alpha3": "GMB",
        "numericCode": 270,
        "avgLatitude": 13.4667,
        "avgLongitude": -16.5667
    },
    {
        "country": "Georgia",
        "alpha2": "GE",
        "alpha3": "GEO",
        "numericCode": 268,
        "avgLatitude": 42,
        "avgLongitude": 43.5
    },
    {
        "country": "Germany",
        "alpha2": "DE",
        "alpha3": "DEU",
        "numericCode": 276,
        "avgLatitude": 51,
        "avgLongitude": 9
    },
    {
        "country": "Ghana",
        "alpha2": "GH",
        "alpha3": "GHA",
        "numericCode": 288,
        "avgLatitude": 8,
        "avgLongitude": -2
    },
    {
        "country": "Gibraltar",
        "alpha2": "GI",
        "alpha3": "GIB",
        "numericCode": 292,
        "avgLatitude": 36.1833,
        "avgLongitude": -5.3667
    },
    {
        "country": "Greece",
        "alpha2": "GR",
        "alpha3": "GRC",
        "numericCode": 300,
        "avgLatitude": 39,
        "avgLongitude": 22
    },
    {
        "country": "Greenland",
        "alpha2": "GL",
        "alpha3": "GRL",
        "numericCode": 304,
        "avgLatitude": 72,
        "avgLongitude": -40
    },
    {
        "country": "Grenada",
        "alpha2": "GD",
        "alpha3": "GRD",
        "numericCode": 308,
        "avgLatitude": 12.1167,
        "avgLongitude": -61.6667
    },
    {
        "country": "Guadeloupe",
        "alpha2": "GP",
        "alpha3": "GLP",
        "numericCode": 312,
        "avgLatitude": 16.25,
        "avgLongitude": -61.5833
    },
    {
        "country": "Guam",
        "alpha2": "GU",
        "alpha3": "GUM",
        "numericCode": 316,
        "avgLatitude": 13.4667,
        "avgLongitude": 144.7833
    },
    {
        "country": "Guatemala",
        "alpha2": "GT",
        "alpha3": "GTM",
        "numericCode": 320,
        "avgLatitude": 15.5,
        "avgLongitude": -90.25
    },
    {
        "country": "Guernsey",
        "alpha2": "GG",
        "alpha3": "GGY",
        "numericCode": 831,
        "avgLatitude": 49.5,
        "avgLongitude": -2.56
    },
    {
        "country": "Guinea",
        "alpha2": "GN",
        "alpha3": "GIN",
        "numericCode": 324,
        "avgLatitude": 11,
        "avgLongitude": -10
    },
    {
        "country": "Guinea-Bissau",
        "alpha2": "GW",
        "alpha3": "GNB",
        "numericCode": 624,
        "avgLatitude": 12,
        "avgLongitude": -15
    },
    {
        "country": "Guyana",
        "alpha2": "GY",
        "alpha3": "GUY",
        "numericCode": 328,
        "avgLatitude": 5,
        "avgLongitude": -59
    },
    {
        "country": "Haiti",
        "alpha2": "HT",
        "alpha3": "HTI",
        "numericCode": 332,
        "avgLatitude": 19,
        "avgLongitude": -72.4167
    },
    {
        "country": "Heard Island and McDonald Islands",
        "alpha2": "HM",
        "alpha3": "HMD",
        "numericCode": 334,
        "avgLatitude": -53.1,
        "avgLongitude": 72.5167
    },
    {
        "country": "Holy See (Vatican City State)",
        "alpha2": "VA",
        "alpha3": "VAT",
        "numericCode": 336,
        "avgLatitude": 41.9,
        "avgLongitude": 12.45
    },
    {
        "country": "Honduras",
        "alpha2": "HN",
        "alpha3": "HND",
        "numericCode": 340,
        "avgLatitude": 15,
        "avgLongitude": -86.5
    },
    {
        "country": "Hong Kong",
        "alpha2": "HK",
        "alpha3": "HKG",
        "numericCode": 344,
        "avgLatitude": 22.25,
        "avgLongitude": 114.1667
    },
    {
        "country": "Hungary",
        "alpha2": "HU",
        "alpha3": "HUN",
        "numericCode": 348,
        "avgLatitude": 47,
        "avgLongitude": 20
    },
    {
        "country": "Iceland",
        "alpha2": "IS",
        "alpha3": "ISL",
        "numericCode": 352,
        "avgLatitude": 65,
        "avgLongitude": -18
    },
    {
        "country": "India",
        "alpha2": "IN",
        "alpha3": "IND",
        "numericCode": 356,
        "avgLatitude": 20,
        "avgLongitude": 77
    },
    {
        "country": "Indonesia",
        "alpha2": "ID",
        "alpha3": "IDN",
        "numericCode": 360,
        "avgLatitude": -5,
        "avgLongitude": 120
    },
    {
        "country": "Iran, Islamic Republic of",
        "alpha2": "IR",
        "alpha3": "IRN",
        "numericCode": 364,
        "avgLatitude": 32,
        "avgLongitude": 53
    },
    {
        "country": "Iraq",
        "alpha2": "IQ",
        "alpha3": "IRQ",
        "numericCode": 368,
        "avgLatitude": 33,
        "avgLongitude": 44
    },
    {
        "country": "Ireland",
        "alpha2": "IE",
        "alpha3": "IRL",
        "numericCode": 372,
        "avgLatitude": 53,
        "avgLongitude": -8
    },
    {
        "country": "Isle of Man",
        "alpha2": "IM",
        "alpha3": "IMN",
        "numericCode": 833,
        "avgLatitude": 54.23,
        "avgLongitude": -4.55
    },
    {
        "country": "Israel",
        "alpha2": "IL",
        "alpha3": "ISR",
        "numericCode": 376,
        "avgLatitude": 31.5,
        "avgLongitude": 34.75
    },
    {
        "country": "Italy",
        "alpha2": "IT",
        "alpha3": "ITA",
        "numericCode": 380,
        "avgLatitude": 42.8333,
        "avgLongitude": 12.8333
    },
    {
        "country": "Jamaica",
        "alpha2": "JM",
        "alpha3": "JAM",
        "numericCode": 388,
        "avgLatitude": 18.25,
        "avgLongitude": -77.5
    },
    {
        "country": "Japan",
        "alpha2": "JP",
        "alpha3": "JPN",
        "numericCode": 392,
        "avgLatitude": 36,
        "avgLongitude": 138
    },
    {
        "country": "Jersey",
        "alpha2": "JE",
        "alpha3": "JEY",
        "numericCode": 832,
        "avgLatitude": 49.21,
        "avgLongitude": -2.13
    },
    {
        "country": "Jordan",
        "alpha2": "JO",
        "alpha3": "JOR",
        "numericCode": 400,
        "avgLatitude": 31,
        "avgLongitude": 36
    },
    {
        "country": "Kazakhstan",
        "alpha2": "KZ",
        "alpha3": "KAZ",
        "numericCode": 398,
        "avgLatitude": 48,
        "avgLongitude": 68
    },
    {
        "country": "Kenya",
        "alpha2": "KE",
        "alpha3": "KEN",
        "numericCode": 404,
        "avgLatitude": 1,
        "avgLongitude": 38
    },
    {
        "country": "Kiribati",
        "alpha2": "KI",
        "alpha3": "KIR",
        "numericCode": 296,
        "avgLatitude": 1.4167,
        "avgLongitude": 173
    },
    {
        "country": "Korea, Democratic People's Republic of",
        "alpha2": "KP",
        "alpha3": "PRK",
        "numericCode": 408,
        "avgLatitude": 40,
        "avgLongitude": 127
    },
    {
        "country": "Korea, Republic of",
        "alpha2": "KR",
        "alpha3": "KOR",
        "numericCode": 410,
        "avgLatitude": 37,
        "avgLongitude": 127.5
    },
    {
        "country": "South Korea",
        "alpha2": "KR",
        "alpha3": "KOR",
        "numericCode": 410,
        "avgLatitude": 37,
        "avgLongitude": 127.5
    },
    {
        "country": "Kuwait",
        "alpha2": "KW",
        "alpha3": "KWT",
        "numericCode": 414,
        "avgLatitude": 29.3375,
        "avgLongitude": 47.6581
    },
    {
        "country": "Kyrgyzstan",
        "alpha2": "KG",
        "alpha3": "KGZ",
        "numericCode": 417,
        "avgLatitude": 41,
        "avgLongitude": 75
    },
    {
        "country": "Lao People's Democratic Republic",
        "alpha2": "LA",
        "alpha3": "LAO",
        "numericCode": 418,
        "avgLatitude": 18,
        "avgLongitude": 105
    },
    {
        "country": "Latvia",
        "alpha2": "LV",
        "alpha3": "LVA",
        "numericCode": 428,
        "avgLatitude": 57,
        "avgLongitude": 25
    },
    {
        "country": "Lebanon",
        "alpha2": "LB",
        "alpha3": "LBN",
        "numericCode": 422,
        "avgLatitude": 33.8333,
        "avgLongitude": 35.8333
    },
    {
        "country": "Lesotho",
        "alpha2": "LS",
        "alpha3": "LSO",
        "numericCode": 426,
        "avgLatitude": -29.5,
        "avgLongitude": 28.5
    },
    {
        "country": "Liberia",
        "alpha2": "LR",
        "alpha3": "LBR",
        "numericCode": 430,
        "avgLatitude": 6.5,
        "avgLongitude": -9.5
    },
    {
        "country": "Libyan Arab Jamahiriya",
        "alpha2": "LY",
        "alpha3": "LBY",
        "numericCode": 434,
        "avgLatitude": 25,
        "avgLongitude": 17
    },
    {
        "country": "Libya",
        "alpha2": "LY",
        "alpha3": "LBY",
        "numericCode": 434,
        "avgLatitude": 25,
        "avgLongitude": 17
    },
    {
        "country": "Liechtenstein",
        "alpha2": "LI",
        "alpha3": "LIE",
        "numericCode": 438,
        "avgLatitude": 47.1667,
        "avgLongitude": 9.5333
    },
    {
        "country": "Lithuania",
        "alpha2": "LT",
        "alpha3": "LTU",
        "numericCode": 440,
        "avgLatitude": 56,
        "avgLongitude": 24
    },
    {
        "country": "Luxembourg",
        "alpha2": "LU",
        "alpha3": "LUX",
        "numericCode": 442,
        "avgLatitude": 49.75,
        "avgLongitude": 6.1667
    },
    {
        "country": "Macao",
        "alpha2": "MO",
        "alpha3": "MAC",
        "numericCode": 446,
        "avgLatitude": 22.1667,
        "avgLongitude": 113.55
    },
    {
        "country": "Macedonia, the former Yugoslav Republic of",
        "alpha2": "MK",
        "alpha3": "MKD",
        "numericCode": 807,
        "avgLatitude": 41.8333,
        "avgLongitude": 22
    },
    {
        "country": "Madagascar",
        "alpha2": "MG",
        "alpha3": "MDG",
        "numericCode": 450,
        "avgLatitude": -20,
        "avgLongitude": 47
    },
    {
        "country": "Malawi",
        "alpha2": "MW",
        "alpha3": "MWI",
        "numericCode": 454,
        "avgLatitude": -13.5,
        "avgLongitude": 34
    },
    {
        "country": "Malaysia",
        "alpha2": "MY",
        "alpha3": "MYS",
        "numericCode": 458,
        "avgLatitude": 2.5,
        "avgLongitude": 112.5
    },
    {
        "country": "Maldives",
        "alpha2": "MV",
        "alpha3": "MDV",
        "numericCode": 462,
        "avgLatitude": 3.25,
        "avgLongitude": 73
    },
    {
        "country": "Mali",
        "alpha2": "ML",
        "alpha3": "MLI",
        "numericCode": 466,
        "avgLatitude": 17,
        "avgLongitude": -4
    },
    {
        "country": "Malta",
        "alpha2": "MT",
        "alpha3": "MLT",
        "numericCode": 470,
        "avgLatitude": 35.8333,
        "avgLongitude": 14.5833
    },
    {
        "country": "Marshall Islands",
        "alpha2": "MH",
        "alpha3": "MHL",
        "numericCode": 584,
        "avgLatitude": 9,
        "avgLongitude": 168
    },
    {
        "country": "Martinique",
        "alpha2": "MQ",
        "alpha3": "MTQ",
        "numericCode": 474,
        "avgLatitude": 14.6667,
        "avgLongitude": -61
    },
    {
        "country": "Mauritania",
        "alpha2": "MR",
        "alpha3": "MRT",
        "numericCode": 478,
        "avgLatitude": 20,
        "avgLongitude": -12
    },
    {
        "country": "Mauritius",
        "alpha2": "MU",
        "alpha3": "MUS",
        "numericCode": 480,
        "avgLatitude": -20.2833,
        "avgLongitude": 57.55
    },
    {
        "country": "Mayotte",
        "alpha2": "YT",
        "alpha3": "MYT",
        "numericCode": 175,
        "avgLatitude": -12.8333,
        "avgLongitude": 45.1667
    },
    {
        "country": "Mexico",
        "alpha2": "MX",
        "alpha3": "MEX",
        "numericCode": 484,
        "avgLatitude": 23,
        "avgLongitude": -102
    },
    {
        "country": "Micronesia, Federated States of",
        "alpha2": "FM",
        "alpha3": "FSM",
        "numericCode": 583,
        "avgLatitude": 6.9167,
        "avgLongitude": 158.25
    },
    {
        "country": "Moldova, Republic of",
        "alpha2": "MD",
        "alpha3": "MDA",
        "numericCode": 498,
        "avgLatitude": 47,
        "avgLongitude": 29
    },
    {
        "country": "Monaco",
        "alpha2": "MC",
        "alpha3": "MCO",
        "numericCode": 492,
        "avgLatitude": 43.7333,
        "avgLongitude": 7.4
    },
    {
        "country": "Mongolia",
        "alpha2": "MN",
        "alpha3": "MNG",
        "numericCode": 496,
        "avgLatitude": 46,
        "avgLongitude": 105
    },
    {
        "country": "Montenegro",
        "alpha2": "ME",
        "alpha3": "MNE",
        "numericCode": 499,
        "avgLatitude": 42,
        "avgLongitude": 19
    },
    {
        "country": "Montserrat",
        "alpha2": "MS",
        "alpha3": "MSR",
        "numericCode": 500,
        "avgLatitude": 16.75,
        "avgLongitude": -62.2
    },
    {
        "country": "Morocco",
        "alpha2": "MA",
        "alpha3": "MAR",
        "numericCode": 504,
        "avgLatitude": 32,
        "avgLongitude": -5
    },
    {
        "country": "Mozambique",
        "alpha2": "MZ",
        "alpha3": "MOZ",
        "numericCode": 508,
        "avgLatitude": -18.25,
        "avgLongitude": 35
    },
    {
        "country": "Myanmar",
        "alpha2": "MM",
        "alpha3": "MMR",
        "numericCode": 104,
        "avgLatitude": 22,
        "avgLongitude": 98
    },
    {
        "country": "Burma",
        "alpha2": "MM",
        "alpha3": "MMR",
        "numericCode": 104,
        "avgLatitude": 22,
        "avgLongitude": 98
    },
    {
        "country": "Namibia",
        "alpha2": "NA",
        "alpha3": "NAM",
        "numericCode": 516,
        "avgLatitude": -22,
        "avgLongitude": 17
    },
    {
        "country": "Nauru",
        "alpha2": "NR",
        "alpha3": "NRU",
        "numericCode": 520,
        "avgLatitude": -0.5333,
        "avgLongitude": 166.9167
    },
    {
        "country": "Nepal",
        "alpha2": "NP",
        "alpha3": "NPL",
        "numericCode": 524,
        "avgLatitude": 28,
        "avgLongitude": 84
    },
    {
        "country": "Netherlands",
        "alpha2": "NL",
        "alpha3": "NLD",
        "numericCode": 528,
        "avgLatitude": 52.5,
        "avgLongitude": 5.75
    },
    {
        "country": "Netherlands Antilles",
        "alpha2": "AN",
        "alpha3": "ANT",
        "numericCode": 530,
        "avgLatitude": 12.25,
        "avgLongitude": -68.75
    },
    {
        "country": "New Caledonia",
        "alpha2": "NC",
        "alpha3": "NCL",
        "numericCode": 540,
        "avgLatitude": -21.5,
        "avgLongitude": 165.5
    },
    {
        "country": "New Zealand",
        "alpha2": "NZ",
        "alpha3": "NZL",
        "numericCode": 554,
        "avgLatitude": -41,
        "avgLongitude": 174
    },
    {
        "country": "Nicaragua",
        "alpha2": "NI",
        "alpha3": "NIC",
        "numericCode": 558,
        "avgLatitude": 13,
        "avgLongitude": -85
    },
    {
        "country": "Niger",
        "alpha2": "NE",
        "alpha3": "NER",
        "numericCode": 562,
        "avgLatitude": 16,
        "avgLongitude": 8
    },
    {
        "country": "Nigeria",
        "alpha2": "NG",
        "alpha3": "NGA",
        "numericCode": 566,
        "avgLatitude": 10,
        "avgLongitude": 8
    },
    {
        "country": "Niue",
        "alpha2": "NU",
        "alpha3": "NIU",
        "numericCode": 570,
        "avgLatitude": -19.0333,
        "avgLongitude": -169.8667
    },
    {
        "country": "Norfolk Island",
        "alpha2": "NF",
        "alpha3": "NFK",
        "numericCode": 574,
        "avgLatitude": -29.0333,
        "avgLongitude": 167.95
    },
    {
        "country": "Northern Mariana Islands",
        "alpha2": "MP",
        "alpha3": "MNP",
        "numericCode": 580,
        "avgLatitude": 15.2,
        "avgLongitude": 145.75
    },
    {
        "country": "Norway",
        "alpha2": "NO",
        "alpha3": "NOR",
        "numericCode": 578,
        "avgLatitude": 62,
        "avgLongitude": 10
    },
    {
        "country": "Oman",
        "alpha2": "OM",
        "alpha3": "OMN",
        "numericCode": 512,
        "avgLatitude": 21,
        "avgLongitude": 57
    },
    {
        "country": "Pakistan",
        "alpha2": "PK",
        "alpha3": "PAK",
        "numericCode": 586,
        "avgLatitude": 30,
        "avgLongitude": 70
    },
    {
        "country": "Palau",
        "alpha2": "PW",
        "alpha3": "PLW",
        "numericCode": 585,
        "avgLatitude": 7.5,
        "avgLongitude": 134.5
    },
    {
        "country": "Palestinian Territory, Occupied",
        "alpha2": "PS",
        "alpha3": "PSE",
        "numericCode": 275,
        "avgLatitude": 32,
        "avgLongitude": 35.25
    },
    {
        "country": "Panama",
        "alpha2": "PA",
        "alpha3": "PAN",
        "numericCode": 591,
        "avgLatitude": 9,
        "avgLongitude": -80
    },
    {
        "country": "Papua New Guinea",
        "alpha2": "PG",
        "alpha3": "PNG",
        "numericCode": 598,
        "avgLatitude": -6,
        "avgLongitude": 147
    },
    {
        "country": "Paraguay",
        "alpha2": "PY",
        "alpha3": "PRY",
        "numericCode": 600,
        "avgLatitude": -23,
        "avgLongitude": -58
    },
    {
        "country": "Peru",
        "alpha2": "PE",
        "alpha3": "PER",
        "numericCode": 604,
        "avgLatitude": -10,
        "avgLongitude": -76
    },
    {
        "country": "Philippines",
        "alpha2": "PH",
        "alpha3": "PHL",
        "numericCode": 608,
        "avgLatitude": 13,
        "avgLongitude": 122
    },
    {
        "country": "Pitcairn",
        "alpha2": "PN",
        "alpha3": "PCN",
        "numericCode": 612,
        "avgLatitude": -24.7,
        "avgLongitude": -127.4
    },
    {
        "country": "Poland",
        "alpha2": "PL",
        "alpha3": "POL",
        "numericCode": 616,
        "avgLatitude": 52,
        "avgLongitude": 20
    },
    {
        "country": "Portugal",
        "alpha2": "PT",
        "alpha3": "PRT",
        "numericCode": 620,
        "avgLatitude": 39.5,
        "avgLongitude": -8
    },
    {
        "country": "Puerto Rico",
        "alpha2": "PR",
        "alpha3": "PRI",
        "numericCode": 630,
        "avgLatitude": 18.25,
        "avgLongitude": -66.5
    },
    {
        "country": "Qatar",
        "alpha2": "QA",
        "alpha3": "QAT",
        "numericCode": 634,
        "avgLatitude": 25.5,
        "avgLongitude": 51.25
    },
    {
        "country": "Réunion",
        "alpha2": "RE",
        "alpha3": "REU",
        "numericCode": 638,
        "avgLatitude": -21.1,
        "avgLongitude": 55.6
    },
    {
        "country": "Romania",
        "alpha2": "RO",
        "alpha3": "ROU",
        "numericCode": 642,
        "avgLatitude": 46,
        "avgLongitude": 25
    },
    {
        "country": "Russian Federation",
        "alpha2": "RU",
        "alpha3": "RUS",
        "numericCode": 643,
        "avgLatitude": 60,
        "avgLongitude": 100
    },
    {
        "country": "Russia",
        "alpha2": "RU",
        "alpha3": "RUS",
        "numericCode": 643,
        "avgLatitude": 60,
        "avgLongitude": 100
    },
    {
        "country": "Rwanda",
        "alpha2": "RW",
        "alpha3": "RWA",
        "numericCode": 646,
        "avgLatitude": -2,
        "avgLongitude": 30
    },
    {
        "country": "Saint Helena, Ascension and Tristan da Cunha",
        "alpha2": "SH",
        "alpha3": "SHN",
        "numericCode": 654,
        "avgLatitude": -15.9333,
        "avgLongitude": -5.7
    },
    {
        "country": "Saint Kitts and Nevis",
        "alpha2": "KN",
        "alpha3": "KNA",
        "numericCode": 659,
        "avgLatitude": 17.3333,
        "avgLongitude": -62.75
    },
    {
        "country": "Saint Lucia",
        "alpha2": "LC",
        "alpha3": "LCA",
        "numericCode": 662,
        "avgLatitude": 13.8833,
        "avgLongitude": -61.1333
    },
    {
        "country": "Saint Pierre and Miquelon",
        "alpha2": "PM",
        "alpha3": "SPM",
        "numericCode": 666,
        "avgLatitude": 46.8333,
        "avgLongitude": -56.3333
    },
    {
        "country": "Saint Vincent and the Grenadines",
        "alpha2": "VC",
        "alpha3": "VCT",
        "numericCode": 670,
        "avgLatitude": 13.25,
        "avgLongitude": -61.2
    },
    {
        "country": "Saint Vincent & the Grenadines",
        "alpha2": "VC",
        "alpha3": "VCT",
        "numericCode": 670,
        "avgLatitude": 13.25,
        "avgLongitude": -61.2
    },
    {
        "country": "St. Vincent and the Grenadines",
        "alpha2": "VC",
        "alpha3": "VCT",
        "numericCode": 670,
        "avgLatitude": 13.25,
        "avgLongitude": -61.2
    },
    {
        "country": "Samoa",
        "alpha2": "WS",
        "alpha3": "WSM",
        "numericCode": 882,
        "avgLatitude": -13.5833,
        "avgLongitude": -172.3333
    },
    {
        "country": "San Marino",
        "alpha2": "SM",
        "alpha3": "SMR",
        "numericCode": 674,
        "avgLatitude": 43.7667,
        "avgLongitude": 12.4167
    },
    {
        "country": "Sao Tome and Principe",
        "alpha2": "ST",
        "alpha3": "STP",
        "numericCode": 678,
        "avgLatitude": 1,
        "avgLongitude": 7
    },
    {
        "country": "Saudi Arabia",
        "alpha2": "SA",
        "alpha3": "SAU",
        "numericCode": 682,
        "avgLatitude": 25,
        "avgLongitude": 45
    },
    {
        "country": "Senegal",
        "alpha2": "SN",
        "alpha3": "SEN",
        "numericCode": 686,
        "avgLatitude": 14,
        "avgLongitude": -14
    },
    {
        "country": "Serbia",
        "alpha2": "RS",
        "alpha3": "SRB",
        "numericCode": 688,
        "avgLatitude": 44,
        "avgLongitude": 21
    },
    {
        "country": "Seychelles",
        "alpha2": "SC",
        "alpha3": "SYC",
        "numericCode": 690,
        "avgLatitude": -4.5833,
        "avgLongitude": 55.6667
    },
    {
        "country": "Sierra Leone",
        "alpha2": "SL",
        "alpha3": "SLE",
        "numericCode": 694,
        "avgLatitude": 8.5,
        "avgLongitude": -11.5
    },
    {
        "country": "Singapore",
        "alpha2": "SG",
        "alpha3": "SGP",
        "numericCode": 702,
        "avgLatitude": 1.3667,
        "avgLongitude": 103.8
    },
    {
        "country": "Slovakia",
        "alpha2": "SK",
        "alpha3": "SVK",
        "numericCode": 703,
        "avgLatitude": 48.6667,
        "avgLongitude": 19.5
    },
    {
        "country": "Slovenia",
        "alpha2": "SI",
        "alpha3": "SVN",
        "numericCode": 705,
        "avgLatitude": 46,
        "avgLongitude": 15
    },
    {
        "country": "Solomon Islands",
        "alpha2": "SB",
        "alpha3": "SLB",
        "numericCode": 90,
        "avgLatitude": -8,
        "avgLongitude": 159
    },
    {
        "country": "Somalia",
        "alpha2": "SO",
        "alpha3": "SOM",
        "numericCode": 706,
        "avgLatitude": 10,
        "avgLongitude": 49
    },
    {
        "country": "South Africa",
        "alpha2": "ZA",
        "alpha3": "ZAF",
        "numericCode": 710,
        "avgLatitude": -29,
        "avgLongitude": 24
    },
    {
        "country": "South Georgia and the South Sandwich Islands",
        "alpha2": "GS",
        "alpha3": "SGS",
        "numericCode": 239,
        "avgLatitude": -54.5,
        "avgLongitude": -37
    },
    {
        "country": "South Sudan",
        "alpha2": "SS",
        "alpha3": "SSD",
        "numericCode": 728,
        "avgLatitude": 8,
        "avgLongitude": 30
    },
    {
        "country": "Spain",
        "alpha2": "ES",
        "alpha3": "ESP",
        "numericCode": 724,
        "avgLatitude": 40,
        "avgLongitude": -4
    },
    {
        "country": "Sri Lanka",
        "alpha2": "LK",
        "alpha3": "LKA",
        "numericCode": 144,
        "avgLatitude": 7,
        "avgLongitude": 81
    },
    {
        "country": "Sudan",
        "alpha2": "SD",
        "alpha3": "SDN",
        "numericCode": 736,
        "avgLatitude": 15,
        "avgLongitude": 30
    },
    {
        "country": "Suriname",
        "alpha2": "SR",
        "alpha3": "SUR",
        "numericCode": 740,
        "avgLatitude": 4,
        "avgLongitude": -56
    },
    {
        "country": "Svalbard and Jan Mayen",
        "alpha2": "SJ",
        "alpha3": "SJM",
        "numericCode": 744,
        "avgLatitude": 78,
        "avgLongitude": 20
    },
    {
        "country": "Swaziland",
        "alpha2": "SZ",
        "alpha3": "SWZ",
        "numericCode": 748,
        "avgLatitude": -26.5,
        "avgLongitude": 31.5
    },
    {
        "country": "Sweden",
        "alpha2": "SE",
        "alpha3": "SWE",
        "numericCode": 752,
        "avgLatitude": 62,
        "avgLongitude": 15
    },
    {
        "country": "Switzerland",
        "alpha2": "CH",
        "alpha3": "CHE",
        "numericCode": 756,
        "avgLatitude": 47,
        "avgLongitude": 8
    },
    {
        "country": "Syrian Arab Republic",
        "alpha2": "SY",
        "alpha3": "SYR",
        "numericCode": 760,
        "avgLatitude": 35,
        "avgLongitude": 38
    },
    {
        "country": "Taiwan, Province of China",
        "alpha2": "TW",
        "alpha3": "TWN",
        "numericCode": 158,
        "avgLatitude": 23.5,
        "avgLongitude": 121
    },
    {
        "country": "Taiwan",
        "alpha2": "TW",
        "alpha3": "TWN",
        "numericCode": 158,
        "avgLatitude": 23.5,
        "avgLongitude": 121
    },
    {
        "country": "Tajikistan",
        "alpha2": "TJ",
        "alpha3": "TJK",
        "numericCode": 762,
        "avgLatitude": 39,
        "avgLongitude": 71
    },
    {
        "country": "Tanzania, United Republic of",
        "alpha2": "TZ",
        "alpha3": "TZA",
        "numericCode": 834,
        "avgLatitude": -6,
        "avgLongitude": 35
    },
    {
        "country": "Thailand",
        "alpha2": "TH",
        "alpha3": "THA",
        "numericCode": 764,
        "avgLatitude": 15,
        "avgLongitude": 100
    },
    {
        "country": "Timor-Leste",
        "alpha2": "TL",
        "alpha3": "TLS",
        "numericCode": 626,
        "avgLatitude": -8.55,
        "avgLongitude": 125.5167
    },
    {
        "country": "Togo",
        "alpha2": "TG",
        "alpha3": "TGO",
        "numericCode": 768,
        "avgLatitude": 8,
        "avgLongitude": 1.1667
    },
    {
        "country": "Tokelau",
        "alpha2": "TK",
        "alpha3": "TKL",
        "numericCode": 772,
        "avgLatitude": -9,
        "avgLongitude": -172
    },
    {
        "country": "Tonga",
        "alpha2": "TO",
        "alpha3": "TON",
        "numericCode": 776,
        "avgLatitude": -20,
        "avgLongitude": -175
    },
    {
        "country": "Trinidad and Tobago",
        "alpha2": "TT",
        "alpha3": "TTO",
        "numericCode": 780,
        "avgLatitude": 11,
        "avgLongitude": -61
    },
    {
        "country": "Tunisia",
        "alpha2": "TN",
        "alpha3": "TUN",
        "numericCode": 788,
        "avgLatitude": 34,
        "avgLongitude": 9
    },
    {
        "country": "Turkey",
        "alpha2": "TR",
        "alpha3": "TUR",
        "numericCode": 792,
        "avgLatitude": 39,
        "avgLongitude": 35
    },
    {
        "country": "Turkmenistan",
        "alpha2": "TM",
        "alpha3": "TKM",
        "numericCode": 795,
        "avgLatitude": 40,
        "avgLongitude": 60
    },
    {
        "country": "Turks and Caicos Islands",
        "alpha2": "TC",
        "alpha3": "TCA",
        "numericCode": 796,
        "avgLatitude": 21.75,
        "avgLongitude": -71.5833
    },
    {
        "country": "Tuvalu",
        "alpha2": "TV",
        "alpha3": "TUV",
        "numericCode": 798,
        "avgLatitude": -8,
        "avgLongitude": 178
    },
    {
        "country": "Uganda",
        "alpha2": "UG",
        "alpha3": "UGA",
        "numericCode": 800,
        "avgLatitude": 1,
        "avgLongitude": 32
    },
    {
        "country": "Ukraine",
        "alpha2": "UA",
        "alpha3": "UKR",
        "numericCode": 804,
        "avgLatitude": 49,
        "avgLongitude": 32
    },
    {
        "country": "United Arab Emirates",
        "alpha2": "AE",
        "alpha3": "ARE",
        "numericCode": 784,
        "avgLatitude": 24,
        "avgLongitude": 54
    },
    {
        "country": "United Kingdom",
        "alpha2": "GB",
        "alpha3": "GBR",
        "numericCode": 826,
        "avgLatitude": 54,
        "avgLongitude": -2
    },
    {
        "country": "United States",
        "alpha2": "US",
        "alpha3": "USA",
        "numericCode": 840,
        "avgLatitude": 38,
        "avgLongitude": -97
    },
    {
        "country": "United States Minor Outlying Islands",
        "alpha2": "UM",
        "alpha3": "UMI",
        "numericCode": 581,
        "avgLatitude": 19.2833,
        "avgLongitude": 166.6
    },
    {
        "country": "Uruguay",
        "alpha2": "UY",
        "alpha3": "URY",
        "numericCode": 858,
        "avgLatitude": -33,
        "avgLongitude": -56
    },
    {
        "country": "Uzbekistan",
        "alpha2": "UZ",
        "alpha3": "UZB",
        "numericCode": 860,
        "avgLatitude": 41,
        "avgLongitude": 64
    },
    {
        "country": "Vanuatu",
        "alpha2": "VU",
        "alpha3": "VUT",
        "numericCode": 548,
        "avgLatitude": -16,
        "avgLongitude": 167
    },
    {
        "country": "Venezuela, Bolivarian Republic of",
        "alpha2": "VE",
        "alpha3": "VEN",
        "numericCode": 862,
        "avgLatitude": 8,
        "avgLongitude": -66
    },
    {
        "country": "Venezuela",
        "alpha2": "VE",
        "alpha3": "VEN",
        "numericCode": 862,
        "avgLatitude": 8,
        "avgLongitude": -66
    },
    {
        "country": "Viet Nam",
        "alpha2": "VN",
        "alpha3": "VNM",
        "numericCode": 704,
        "avgLatitude": 16,
        "avgLongitude": 106
    },
    {
        "country": "Vietnam",
        "alpha2": "VN",
        "alpha3": "VNM",
        "numericCode": 704,
        "avgLatitude": 16,
        "avgLongitude": 106
    },
    {
        "country": "Virgin Islands, British",
        "alpha2": "VG",
        "alpha3": "VGB",
        "numericCode": 92,
        "avgLatitude": 18.5,
        "avgLongitude": -64.5
    },
    {
        "country": "Virgin Islands, U.S.",
        "alpha2": "VI",
        "alpha3": "VIR",
        "numericCode": 850,
        "avgLatitude": 18.3333,
        "avgLongitude": -64.8333
    },
    {
        "country": "Wallis and Futuna",
        "alpha2": "WF",
        "alpha3": "WLF",
        "numericCode": 876,
        "avgLatitude": -13.3,
        "avgLongitude": -176.2
    },
    {
        "country": "Western Sahara",
        "alpha2": "EH",
        "alpha3": "ESH",
        "numericCode": 732,
        "avgLatitude": 24.5,
        "avgLongitude": -13
    },
    {
        "country": "Yemen",
        "alpha2": "YE",
        "alpha3": "YEM",
        "numericCode": 887,
        "avgLatitude": 15,
        "avgLongitude": 48
    },
    {
        "country": "Zambia",
        "alpha2": "ZM",
        "alpha3": "ZMB",
        "numericCode": 894,
        "avgLatitude": -15,
        "avgLongitude": 30
    },
    {
        "country": "Zimbabwe",
        "alpha2": "ZW",
        "alpha3": "ZWE",
        "numericCode": 716,
        "avgLatitude": -20,
        "avgLongitude": 30
    }
];